import { cn } from '@/lib/utils'

const BASE_CLASSES = 'bg-cards-bg font-semibold font-main-font text-text-color text-center md:text-left'

const SIZE_CLASSES = {
  sm: 'text-sm xl:text-base',
  base: 'text-base xl:text-lg',
  lg: 'text-lg xl:text-xl',
  xl: 'text-xl xl:text-2xl',
} as const

interface SectionHeaderProps {
  children: React.ReactNode
  size?: keyof typeof SIZE_CLASSES
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  centered?: boolean
  className?: string
}

/**
 * SectionHeader - Section heading with background bar
 *
 * Self-contained UiBlock with baked-in project styles.
 *
 * @param centered - When true, centers text on md+ screens and adds vertical padding.
 *                   Equivalent to `md:text-center md:py-4 leading-[3]`.
 */
export function SectionHeader({
  children,
  size = 'sm',
  as: Tag = 'h2',
  centered,
  className,
}: SectionHeaderProps) {
  return (
    <Tag className={cn(BASE_CLASSES, SIZE_CLASSES[size], centered && 'md:text-center md:py-4 leading-[3]', className)}>
      {children}
    </Tag>
  )
}
